// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

.a_k62ONipoCOvPkLSGuQ {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3rem;
  width: 100%;
  height: 92vh;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .UZPZcJU5YeTFzIuYGXjx {
  display: flex;
  align-items: center;
  width: 50%;
  height: 100%;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .UZPZcJU5YeTFzIuYGXjx .lPHfdj1CmXv_oqXfoGTx {
  position: relative;
  left: -20%;
  width: 100%;
  height: 100%;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng {
  width: 50%;
  height: 71%;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  height: 100%;
  align-items: flex-start;
  margin-top: 10%;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .OtagNPDNa9vLqPwzKxtp {
  display: flex;
  min-height: 98px;
  width: 100%;
  scale: 1.3;
  padding-left: 4rem;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .G2lG2AvVE_dGE9QdiN7p {
  width: 50%;
  min-width: 352px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .G2lG2AvVE_dGE9QdiN7p .UWaqWs4VvrfND7r76QrA {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .G2lG2AvVE_dGE9QdiN7p .UWaqWs4VvrfND7r76QrA .rG2F7UJmE0uHqsuwU_e1 {
  width: 100%;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .G2lG2AvVE_dGE9QdiN7p .UWaqWs4VvrfND7r76QrA .GaXe7tQX68ZNRRRWmhp9 {
  position: relative;
  padding-left: 0.8rem;
  padding-top: 1.8rem;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .UPbVDin611SSpsZmG_5p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .UPbVDin611SSpsZmG_5p .phStKYwpImVMxa3Uu2_k {
  display: flex;
  align-items: center;
}
.a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .UPbVDin611SSpsZmG_5p .zvPYCBqNMvRBLosuG3xV {
  display: flex;
  justify-content: start;
  align-items: center;
  margin: 2vh 0;
}

@media (max-width: 1024px) {
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL {
    flex-direction: column;
  }
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .UZPZcJU5YeTFzIuYGXjx {
    display: none;
  }
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng {
    width: 100%;
    height: 80%;
  }
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d {
    align-items: center;
    justify-content: space-evenly;
    gap: 1.5rem;
  }
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .OtagNPDNa9vLqPwzKxtp {
    width: fit-content;
    scale: 2.5;
    margin: 0;
    padding: 0 0 0 8rem;
  }
  .a_k62ONipoCOvPkLSGuQ .WghG785royTUe8ONjBAR {
    width: 100%;
  }
}
@media (min-width: 1025px) and (max-width: 1439px) {
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL {
    gap: 1rem;
  }
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .OtagNPDNa9vLqPwzKxtp {
    scale: 1.1;
    padding-left: 0;
  }
}
@media (min-width: 1440px) {
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .OtagNPDNa9vLqPwzKxtp {
    scale: 1.3;
    padding-left: 3rem;
  }
}
@media (min-width: 1920px) and (max-width: 2559px) {
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .OtagNPDNa9vLqPwzKxtp {
    scale: 1.5;
    padding-left: 8rem;
  }
}
@media (min-width: 2560px) and (max-width: 3839px) {
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .OtagNPDNa9vLqPwzKxtp {
    scale: 1.8;
    padding-left: 15.6rem;
  }
}
@media (min-width: 3840px) {
  .a_k62ONipoCOvPkLSGuQ .NiaQc5PX1INKCQVuf_NL .os8cems_2DfQnfZL43ng .RwPXkoY8mWkBsW3O5K8d .OtagNPDNa9vLqPwzKxtp {
    scale: 2.2;
    padding-left: 31rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/componentes/Login/login.module.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AACR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AACZ;AACY;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAChB;AAGQ;EACI,UAAA;EACA,WAAA;AADZ;AAGY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AADhB;AAGgB;EACI,aAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AADpB;AAIgB;EACI,UAAA;EACA,gBAAA;EAEA,aAAA;EACA,sBAAA;EACA,SAAA;AAHpB;AAIoB;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AAFxB;AAGwB;EACI,WAAA;AAD5B;AAGwB;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;AAD5B;AAMgB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAJpB;AAMoB;EACI,aAAA;EACA,mBAAA;AAJxB;AAOoB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AALxB;;AAaA;EAEQ;IACI,sBAAA;EAXV;EAaU;IACI,aAAA;EAXd;EAcU;IACI,WAAA;IACA,WAAA;EAZd;EAac;IACI,mBAAA;IACA,6BAAA;IACA,WAAA;EAXlB;EAYkB;IACI,kBAAA;IACA,UAAA;IACA,SAAA;IACA,mBAAA;EAVtB;EAeM;IACI,WAAA;EAbV;AACF;AAiBA;EACI;IAEI,SAAA;EAhBN;EAkBM;IAGI,UAAA;IACA,eAAA;EAlBV;AACF;AAuBA;EACI;IAEI,UAAA;IACA,kBAAA;EAtBN;AACF;AAyBA;EACI;IAEI,UAAA;IACA,kBAAA;EAxBN;AACF;AA2BA;EACI;IAEI,UAAA;IACA,qBAAA;EA1BN;AACF;AA6BA;EACI;IAEI,UAAA;IACA,mBAAA;EA5BN;AACF","sourcesContent":["*{\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    overflow: hidden;\r\n\r\n    .conteudo {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        gap: 3rem;\r\n        width: 100%;\r\n        height: 92vh;\r\n\r\n        .conteudoEsquerda {\r\n            display: flex;\r\n            align-items: center;\r\n            width: 50%;\r\n            height: 100%;\r\n\r\n            .logo {\r\n                position: relative;\r\n                left: -20%;\r\n                width: 100%;\r\n                height: 100%;\r\n            }\r\n        }\r\n\r\n        .conteudoDireita {\r\n            width: 50%;\r\n            height: 71%;\r\n\r\n            .loginForm {\r\n                display: flex;\r\n                flex-direction: column;\r\n                gap: 1rem;\r\n                width: 100%;\r\n                height: 100%;\r\n                align-items: flex-start;\r\n                margin-top: 10%;\r\n\r\n                .cabecalho {\r\n                    display: flex;\r\n                    min-height: 98px;\r\n                    width: 100%;\r\n                    scale: 1.3;\r\n                    padding-left: 4rem;\r\n                }\r\n\r\n                .inputs {\r\n                    width: 50%;\r\n                    min-width: 352px;\r\n                    // margin: 4vh 0 2vh 0;\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    gap: 32px;\r\n                    .campos {\r\n                        display: flex;\r\n                        width: 100%;\r\n                        align-items: center;\r\n                        justify-content: space-between;\r\n                        .textfield {\r\n                            width: 100%;\r\n                        }\r\n                        .tooltip {\r\n                            position: relative;\r\n                            padding-left: 0.8rem;\r\n                            padding-top: 1.8rem;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .inferiorForm {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    justify-content: space-between;\r\n                    gap: 32px;\r\n\r\n                    .capsLockAtivo {\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n\r\n                    .botao {\r\n                        display: flex;\r\n                        justify-content: start;\r\n                        align-items: center;\r\n                        margin: 2vh 0;\r\n                    }\r\n                }\r\n\r\n            }\r\n        }\r\n    }\r\n}\r\n@media (max-width: 1024px) {\r\n    .container {\r\n        .conteudo {\r\n            flex-direction: column;\r\n\r\n            .conteudoEsquerda {\r\n                display: none;\r\n            }\r\n\r\n            .conteudoDireita {\r\n                width: 100%;\r\n                height: 80%;\r\n                .loginForm {\r\n                    align-items: center;\r\n                    justify-content: space-evenly;\r\n                    gap: 1.5rem;\r\n                    .cabecalho {\r\n                        width: fit-content;\r\n                        scale: 2.5;\r\n                        margin: 0;\r\n                        padding: 0 0 0 8rem;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .rodape {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1025px) and (max-width: 1439px) {\r\n    .container .conteudo \r\n    {\r\n        gap: 1rem;\r\n        \r\n        .conteudoDireita \r\n        .loginForm \r\n        .cabecalho { \r\n            scale: 1.1;\r\n            padding-left: 0;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@media (min-width: 1440px) {\r\n    .container .conteudo .conteudoDireita .loginForm \r\n    .cabecalho { \r\n        scale: 1.3;\r\n        padding-left: 3rem;\r\n    }\r\n}\r\n\r\n@media (min-width: 1920px) and (max-width: 2559px) {\r\n    .container .conteudo .conteudoDireita .loginForm \r\n    .cabecalho { \r\n        scale: 1.5;\r\n        padding-left: 8rem;\r\n    }\r\n}\r\n\r\n@media (min-width: 2560px) and (max-width: 3839px) {\r\n    .container .conteudo .conteudoDireita .loginForm \r\n    .cabecalho { \r\n        scale: 1.8;\r\n        padding-left: 15.6rem;\r\n    }\r\n}\r\n\r\n@media (min-width: 3840px) {\r\n    .container .conteudo .conteudoDireita .loginForm \r\n    .cabecalho { \r\n        scale: 2.2;\r\n        padding-left: 31rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export var container = `a_k62ONipoCOvPkLSGuQ`;
export var conteudo = `NiaQc5PX1INKCQVuf_NL`;
export var conteudoEsquerda = `UZPZcJU5YeTFzIuYGXjx`;
export var logo = `lPHfdj1CmXv_oqXfoGTx`;
export var conteudoDireita = `os8cems_2DfQnfZL43ng`;
export var loginForm = `RwPXkoY8mWkBsW3O5K8d`;
export var cabecalho = `OtagNPDNa9vLqPwzKxtp`;
export var inputs = `G2lG2AvVE_dGE9QdiN7p`;
export var campos = `UWaqWs4VvrfND7r76QrA`;
export var textfield = `rG2F7UJmE0uHqsuwU_e1`;
export var tooltip = `GaXe7tQX68ZNRRRWmhp9`;
export var inferiorForm = `UPbVDin611SSpsZmG_5p`;
export var capsLockAtivo = `phStKYwpImVMxa3Uu2_k`;
export var botao = `zvPYCBqNMvRBLosuG3xV`;
export var rodape = `WghG785royTUe8ONjBAR`;
export default ___CSS_LOADER_EXPORT___;
